// ** React Imports
import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import Spinner from './@core/components/spinner/Fallback-spinner';
import ability from './configs/acl/ability';
import themeConfig from './configs/themeConfig';
import { store } from './redux/store';
import * as serviceWorker from './serviceWorker';
import { AbilityContext } from './utility/context/Can';
import { ThemeContext } from './utility/context/ThemeColors';

import './@core/components/ripple-button';

import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-jsx.min';

import 'react-perfect-scrollbar/dist/css/styles.css';
import '@styles/react/libs/react-hot-toasts/react-hot-toasts.scss';
import '@styles/react/libs/tables/react-dataTable-component.scss';

import './@core/assets/fonts/feather/iconfont.css';
import './@core/scss/core.scss';
import './assets/scss/style.scss';

import './i18n';

const LazyApp = lazy(() => import('./App'));
const container = document.getElementById('root');
const root = createRoot(container);
const persistor = persistStore(store);

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={<Spinner />}>
          <AbilityContext.Provider value={ability}>
            <ThemeContext>
              <LazyApp />
              <Toaster
                position={themeConfig.layout.toastPosition}
                toastOptions={{ className: 'react-hot-toast' }}
              />
            </ThemeContext>
          </AbilityContext.Provider>
        </Suspense>
      </PersistGate>
    </Provider>
  </BrowserRouter>
);

serviceWorker.unregister();
